/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ticket-container[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:44px;height:112px;border-radius:.25rem;image-rendering:high-quality}.ticket-container[_ngcontent-%COMP%]   .ticket-description[_ngcontent-%COMP%]{font-family:Inter,Arial,Helvetica,sans-serif;font-size:1rem;color:#444}.ticket-container[_ngcontent-%COMP%]   .link-text[_ngcontent-%COMP%]{background:#ff6000;color:#fff;text-decoration:none;font-family:PoppinsSemiBold,Arial,Helvetica,sans-serif;border-radius:1rem;padding:.4rem .8rem .2rem .8rem}[_nghost-%COMP%]{display:-webkit-box;display:flex;height:100%}"];
export { styles as styles };
//# sourceMappingURL=initial-ticket.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/progress/initial-ticket/initial-ticket.component.scss.shim.ngstyle.js
// module id = 1610
// module chunks = 26 27 28